import {UiFlashContainer, UiFlashItem} from "mu-widget/lib/components/UiFlash";
import { ComponentBuilder } from "muw-admin/src/services/ComponentBuilder";
import {CheckboxList, InputListVisualParamName, RadioList} from "mu-widget/lib/components/InputList";
import {ChoiceDialog, ChoiceDialogVisualParamName} from "mu-widget/lib/components/ChoiceDialog";
import {VisualParamDef} from "mu-widget/lib/components/VisualParam";

export function customizeFlash(uiFlashContainer: typeof UiFlashContainer, uiFlashItem: typeof UiFlashItem): void
{
    uiFlashContainer.cssClasses.container = ['flash-container'];
    uiFlashItem.cssClasses.container = ['flash-item'];
    uiFlashItem.cssClasses.message = ['flash-item__message'];
    uiFlashItem.cssClasses.content = ['flash-item__content'];
    uiFlashItem.cssClasses.closeButton = ['flash-item__close-button'];
    uiFlashItem.cssClasses.openAnimation = 'animation--from-right';
    uiFlashItem.cssClasses.closeAnimation = 'animation--from-right-r';
    uiFlashItem.ttlDefault = 10;
}

export function customizeAdminComponents(componentBuilder: typeof ComponentBuilder): void
{
    // componentBuilder.classNames.iconPrefix = 'icon--';
}

export function customizeForms(radioList: typeof RadioList, checkboxList: typeof CheckboxList): void
{
    radioList.visualDefaults = {
        ...radioList.visualDefaults,
        itemClass: 'form-check form-check-inline',
        labelTag: 'label',
        labelClass: 'form-check-label',
        controlClass: 'form-check-input',
    };
    checkboxList.visualDefaults = {
        ...checkboxList.visualDefaults,
        itemClass: 'form-check form-check-inline',
        labelTag: 'label',
        labelClass: 'form-check-label',
        controlClass: 'form-check-input',
    };
}

export function layoutMultiline(inputList: RadioList|CheckboxList) {
    inputList.visual.addParamDef({
        itemClass: 'd-block',
        // itemTag: 'div',
    });
}

export function customizeChoiceDialog(choiceDialog: typeof ChoiceDialog) {
    choiceDialog.visualDefaults.buttonContainerClass = 'buttons';
}

export function customizeRadioListBar(visual: VisualParamDef<InputListVisualParamName>, blockItem: boolean = false): VisualParamDef<InputListVisualParamName> {

    visual.containerClass = 'input-list-bar' + (blockItem ? ' input-list-bar--block-item' : '');
    visual.itemTag = 'div';
    visual.itemClass = 'input-list-bar__item';
    visual.labelTag = 'label';


    return visual;
}

